import React from "react";
import { Typography } from "antd";
import DateTime from "../datetime";
import { isFinalStatus } from "./const";

const { Text } = Typography;

/* props
    value: date
    status: string
*/

const DateTimeJob = (props) => {
    return <DateTime value={props.value} isDeadlineActive={!isFinalStatus(props.status)} />;
};

export default DateTimeJob;
